// Minutes limited to 00, 15, 30 and 45. The time wheels only list those (plugins/quarterMinutes.js);
// a time typed in a picker's text box is floored to its quarter here when the picker closes. Takes a
// picker value: timestamps (date and time ranges) or 'HH:mm' strings (time ranges). A value that is
// not an array comes back unchanged.
function floorToQuarter(v) {
  if (typeof v === 'number') {
    const d = new Date(v);
    d.setMinutes(d.getMinutes() - d.getMinutes() % 15, 0, 0);
    return d.getTime();
  }
  if (typeof v === 'string' && /^\d\d:\d\d$/.test(v)) {
    const minutes = Number(v.slice(3));
    return v.slice(0, 3) + ('0' + (minutes - minutes % 15)).slice(-2);
  }
  return v;
}

export default function quarterHour(value) {
  return Array.isArray(value) ? value.map(floorToQuarter) : value;
}
